import React from 'react'
import { Mutation } from 'react-apollo'
import { gql } from 'apollo-boost'
import * as yup from 'yup'
import { Field, Formik } from 'formik'

import TextField from '../TextField'
import ModelSelect from '../Models/Select'
import UserSelect from '../Users/Select'
import Button from '../Button'
import Form, { Group, Heading } from '../Form'

const CREATE_BEACON = gql`
  mutation createBeacon(
  $tag: String!
  $model: ID!
  $owner: ID
  $assignee: ID
  ) {
    createBeacon(
      tag: $tag
      model: $model
      owner: $owner
      assignee: $assignee
    ) {
      id
      tag
      model {
        name
        manufacturer {
          name
        }
      }
      owner {
        firstName
        lastName
      }
      assignee {
        firstName
        lastName
      }
    }
  }
`
const badTag = 'Invalid format (ex: A118001)'
const validationSchema = yup.object().shape({
  tag: yup.string().required('Tag is required').min(7, badTag).max(7, badTag).matches(/[A-Z](\D|\d)[1-2][0-9]\d\d\d/, badTag),
  model: yup.string().required('Model is required')
})

const INITIAL_VALUES = {
  tag: '',
  model: '',
  owner: '',
  assignee: ''
}

const onSubmit = (values, {setSubmitting}, createBeacon) => {
  createBeacon({variables: values})
  setSubmitting(false)
}

const Create = ({onCompleted, onError}) =>
  <Mutation
    mutation={CREATE_BEACON}
    onCompleted={onCompleted}
    onError={onError}>
    {(createBeacon, {loading}) =>
      <Formik
        initialValues={INITIAL_VALUES}
        validationSchema={validationSchema}
        onSubmit={(values, actions) => onSubmit(values, actions, createBeacon)}>
        {({isSubmitting}) =>
          <Form>
            <Heading>General</Heading>
            <Group>
              <Field component={TextField} name='tag' required autoComplete='off' />
              <Field component={ModelSelect} name='model' required />
            </Group>

            <Heading>User</Heading>
            <Group>
              <Field component={UserSelect} name='owner' placeholder='Select an owner...' />
              <Field component={UserSelect} name='assignee' placeholder='Select an assignee...' />
            </Group>

            <Button type='submit' fluid disabled={loading || isSubmitting}>Create New Beacon</Button>
          </Form>
        }
      </Formik>
    }
  </Mutation>

export default Create


// WEBPACK FOOTER //
// ./src/components/Beacons/Create.js